import { jsx as l } from "react/jsx-runtime";
import { c as i } from "react/compiler-runtime";
import { FormHelperText as s } from "@mui/material";
import { forwardRef as f } from "react";
const x = f((m, p) => {
  const e = i(7);
  let r, o;
  e[0] !== m ? ({
    children: r,
    ...o
  } = m, e[0] = m, e[1] = r, e[2] = o) : (r = e[1], o = e[2]);
  let t;
  return e[3] !== r || e[4] !== o || e[5] !== p ? (t = /* @__PURE__ */ l(s, { ref: p, ...o, children: r }), e[3] = r, e[4] = o, e[5] = p, e[6] = t) : t = e[6], t;
});
x.displayName = "FormHelperText";
export {
  x as FormHelperText
};
